function initFooterAccordion() {
  const isMobile = window.innerWidth <= 767;

  document.querySelectorAll('.footer__block--links').forEach(function (block) {
    const heading = block.querySelector('.h6');
    const content = block.querySelector('ul');

    if (!heading || !content) return;

    // Prevent duplicate event listeners
    if (!heading.dataset.accordionBound) {
      heading.dataset.accordionBound = "true";

      heading.addEventListener('click', function () {
        if (window.innerWidth > 767) return;

        const isActive = block.classList.contains('active');

        document.querySelectorAll('.footer__block--links').forEach(function (item) {
          item.classList.remove('active');
          const list = item.querySelector('ul');
          if (list) list.style.display = 'none';
        });

        if (!isActive) {
          block.classList.add('active');
          content.style.display = 'block';
        }
      });
    }

    // Set initial state based on screen size
    if (isMobile) {
      if (!block.classList.contains('active')) {
        content.style.display = 'none';
      }
    } else {
      block.classList.remove('active');
      content.style.display = '';
    }
  });
}

document.addEventListener('DOMContentLoaded', initFooterAccordion);
window.addEventListener('resize', initFooterAccordion);

let fddQuickView = null;
let fddProtectQuickView = false;

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[fdd-modal-trigger]');

  if (trigger) {
    console.debug('fdd_modal trigger');
    console.log('fdd_modal trigger');
    event.preventDefault();

    const fddDate = trigger.getAttribute('data-fdd-date');
    const maxQtyfdd = trigger.getAttribute('data-fdd-qty');

    const variantId = String(
      trigger.getAttribute('data-fdd-variant-id') || ''
    );

    const modal = document.querySelector('.pdp-fdd-modal');

    fddQuickView = trigger.closest('quick-buy-modal[open]');

    // console.debug('fddQuickView',fddQuickView);
    // console.debug('fddOriginalHide top',fddOriginalHide);

    if (fddQuickView && !fddQuickView._fddHidePatched) {
      const originalHide = fddQuickView.hide;

      fddQuickView.hide = function () {
        if (fddProtectQuickView) {
          return;
        }

        return originalHide.apply(this, arguments);
      };

      fddQuickView._fddHidePatched = true;
    }
    console.debug('Current variant ID:', variantId);
    console.log('Current variant ID:', variantId);


    // ==========================================
    // Find the current product/quick-view parent
    // ==========================================

    const productParent = trigger.closest(
      '.shopify-section--main-product, quick-buy-modal'
    );

    console.debug('productParent:', productParent);
    console.log('productParent:', productParent);


    // Find the same variant in cart
    const cartItem = Array.from(
      document.querySelectorAll(
        'cart-drawer line-item quantity-input.quantity-selector__input-wrapper[data-line-item-id]'
      )
    ).find((item) => {
      return String(
        item.getAttribute('data-line-item-id')
      ) === variantId;
    });

    console.debug('Matching cart item:', cartItem);
    console.log('Matching cart item:', cartItem);

    // Quantity of this variant already in cart
    const cartQty = cartItem
      ? Number(cartItem.querySelector('input')?.value || 0)
      : 0;


    // ==========================================
    // Get quantity from current product parent
    // ==========================================

    const quantityInput = productParent
      ? productParent.querySelector('input[name="quantity"]')
      : null;

    const selectedQty = quantityInput
      ? Number(quantityInput.value || 1)
      : 1;


    console.debug('quantityInput:', quantityInput);
    console.debug('maxQty:', maxQtyfdd);
    console.debug('cartQty:', cartQty);
    console.debug('selectedQty:', selectedQty);

    console.log('quantityInput:', quantityInput);
    console.log('maxQty:', maxQtyfdd);
    console.log('cartQty:', cartQty);
    console.log('selectedQty:', selectedQty);


    // If this variant is already in cart and max quantity
    // has been reached, do not open the modal.
    const maxQtyMessages = productParent.querySelectorAll('.fdd-max-qty-message');
    
    if (maxQtyfdd > 0 && cartQty >= maxQtyfdd) {
      console.debug('Maximum quantity already reached');
      console.log('Maximum quantity already reached');
      maxQtyMessages.forEach((maxQtyMessage) => {
        maxQtyMessage.textContent =
          `You've reached the maximum of ${maxQtyfdd} for this item.`;
        maxQtyMessage.hidden = false;
      });

      setTimeout(() => {
        maxQtyMessages.forEach((maxQtyMessage) => {
          maxQtyMessage.hidden = true;
          maxQtyMessage.textContent = '';
        });
      }, 3000);

      return;
    }


    // Calculate remaining quantity
    const remainingQty = maxQtyfdd > 0
      ? Math.max(0, maxQtyfdd - cartQty)
      : selectedQty;

    console.debug('remainingQty:', remainingQty);
    console.log('remainingQty:', remainingQty);


    // If no quantity is remaining, don't open modal.
    if (remainingQty <= 0) {
      console.debug('No remaining quantity available');
      console.log('No remaining quantity available');
      return;
    }


    // Never allow quantity greater than remaining quantity.
    const finalQty = Math.min(
      selectedQty,
      remainingQty
    );

    console.debug('finalQty:', finalQty);


    // Update only the current product/quick-view quantity
    if (quantityInput) {
      quantityInput.value = finalQty;

      quantityInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }


    // ==========================================
    // Store current parent for Agree button
    // ==========================================

    if (modal) {
      modal._fddProductParent = productParent;
      const modalsetDate = modal.querySelector('.Special-date');

      if (modalsetDate) {
        modalsetDate.textContent = fddDate || '';
      }

      modal.classList.add('open');
    }

    return;

    fddQuickView = trigger.closest('quick-buy-modal[open]');

    if (fddQuickView && !fddQuickView._fddHidePatched) {
      const originalHide = fddQuickView.hide;

      fddQuickView.hide = function () {
        if (fddProtectQuickView) {
          return;
        }

        return originalHide.apply(this, arguments);
      };

      fddQuickView._fddHidePatched = true;
    }

    
  }


  // ==========================================
  // Confirm button inside FDD modal
  // ==========================================

  const confirmButton = event.target.closest('.SpecialAgree');

  if (confirmButton) {
    event.preventDefault();

    const modal = document.querySelector('.pdp-fdd-modal');

    if (modal) {
      modal.classList.remove('open');
    }


    // Get the exact product/quick-view parent
    // which opened the modal
    const productParent = modal?._fddProductParent;

    console.debug('FDD product parent:', productParent);
     console.log('FDD product parent:', productParent);

    if (!productParent) {
      console.debug('FDD product parent not found');
      return;
    }


    // ==========================================
    // Find ATC button ONLY inside current parent
    // ==========================================

    const atcSubmitButton = productParent.querySelector(
      'product-form buy-buttons button[type="submit"]'
    );

    console.debug('ATC button:', atcSubmitButton);

    if (!atcSubmitButton) {
      console.debug('ATC button not found');
      return;
    }


    const form = atcSubmitButton.closest('form');

    if (!form) {
      console.debug('ATC form not found');
      return;
    }


    // Submit only the current product / quick-view form
    form.requestSubmit(atcSubmitButton);

    return;
  }


  // ==========================================
  // Close button inside FDD modal
  // ==========================================

  const closeButton = event.target.closest('.SpecialClose, .pdp-fdd-modal .overlay');

  if (closeButton) {
    event.preventDefault();

    const modal = document.querySelector('.pdp-fdd-modal');

    if (modal) {
      modal.classList.remove('open');
      modal._fddProductParent = null;
    }

    return;
  }

});


document.addEventListener('click', function (event) {
  const specialModal = document.querySelector('#SpecialOrder.open');
  if (!specialModal) return;
  const contentBox = event.target.closest('#SpecialOrder .pdp-fdd-modal-inner');
  if (!contentBox) return;

  // Close / Agree / other buttons ko normal behavior do
  if (event.target.closest('button.SpecialAgree')) {
    return;
  }

  // Sirf text/content click ke liye Quick View ko protect karo
  fddProtectQuickView = true;

  // Current click complete hone ke baad flag reset
  setTimeout(() => {
    fddProtectQuickView = false;
  }, 0);
}, true);






// BUY BUTTON TRIGGER
let fddPurchaseType = 'cart';
document.addEventListener('click', function (event) {
  const paymentButton = event.target.closest('[fdd-buy-button-modal-trigger] .shopify-payment-button__button');
  let trigger = event.target.closest('[fdd-buy-button-modal-trigger]');

  if (paymentButton) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    fddPurchaseType = 'checkout';
    trigger = paymentButton.closest('[fdd-buy-button-modal-trigger]');

    if (!trigger) {
      console.debug('FDD payment trigger not found');
      fddPurchaseType = 'cart';
      return;
    }
  } else if (trigger) {
    // Reset the previous Buy Now state for a normal Add to Cart click
    fddPurchaseType = 'cart';
  }

  if (trigger) {
    console.debug('fdd_modal trigger');

    event.preventDefault();

    const fddDate = trigger.getAttribute('data-fdd-date');
    const maxQtyfdd = Number(trigger.getAttribute('data-fdd-qty') || 0);

    const variantId = String(
      trigger.getAttribute('data-fdd-variant-id') || ''
    );

    const modal = document.querySelector('.pdp-fdd-modal');

    fddQuickView = trigger.closest('quick-buy-modal[open]');

    if (fddQuickView && !fddQuickView._fddHidePatched) {
      const originalHide = fddQuickView.hide;

      fddQuickView.hide = function () {
        if (fddProtectQuickView) {
          return;
        }

        return originalHide.apply(this, arguments);
      };

      fddQuickView._fddHidePatched = true;
    }

    console.debug('Current variant ID:', variantId);
    const productParent = trigger.closest('.shopify-section--main-product, quick-buy-modal');

    console.debug('productParent:', productParent);

    const cartItem = Array.from(
      document.querySelectorAll('cart-drawer line-item quantity-input.quantity-selector__input-wrapper[data-line-item-id]')
    ).find((item) => {
      return String(item.getAttribute('data-line-item-id')) === variantId;
    });

    console.debug('Matching cart item:', cartItem);

    const cartQty = cartItem ? Number(cartItem.querySelector('input')?.value || 0) : 0;
    const quantityInput = productParent ? productParent.querySelector('input[name="quantity"]') : null;
    const selectedQty = quantityInput ? Number(quantityInput.value || 1) : 1;
    const maxQtyMessages = productParent?.querySelectorAll('.fdd-max-qty-message') || [];

    if (maxQtyfdd > 0 && cartQty >= maxQtyfdd) {
      maxQtyMessages.forEach((maxQtyMessage) => {
        maxQtyMessage.textContent = `You've reached the maximum of ${maxQtyfdd} for this item.`;
        maxQtyMessage.hidden = false;
      });

      setTimeout(() => {
        maxQtyMessages.forEach((maxQtyMessage) => {
          maxQtyMessage.hidden = true;
          maxQtyMessage.textContent = '';
        });
      }, 3000);

      return;
    }

    const remainingQty = maxQtyfdd > 0 ? Math.max(0, maxQtyfdd - cartQty): selectedQty;
    console.debug('remainingQty:', remainingQty);
    if (remainingQty <= 0) {
      return;
    }

    const finalQty = Math.min(selectedQty, remainingQty);

    console.debug('finalQty:', finalQty);

    if (quantityInput) {
      quantityInput.value = finalQty;
      quantityInput.dispatchEvent(
        new Event('change', { bubbles: true})
      );
    }

    if (modal) {
      modal._fddProductParent = productParent;
      const modalsetDate = modal.querySelector('.Special-date');
      if (modalsetDate) {
        modalsetDate.textContent = fddDate || '';
      }
      modal.classList.add('open');
    }

    return;
  }

  const confirmButton = event.target.closest('.SpecialAgree');

  if (confirmButton) {
    event.preventDefault();
    event.stopPropagation();

    const modal = document.querySelector('.pdp-fdd-modal');

    if (modal) {
      modal.classList.remove('open');
    }

  
   
    if (fddPurchaseType === 'checkout') {
      console.log('FDD Agree → Shopify Payment Button');

      const parentEle =
        modal?._fddProductParent?.closest('.quick-buy-modal-content') ||
        modal?._fddProductParent;

      const paymentButton = parentEle?.querySelector(
        '.for-fdd-trigger .shopify-payment-button__button'
      );

      // Reset before triggering the payment button
      fddPurchaseType = 'cart';

      if (paymentButton) {
        paymentButton.click();
      }

      return;
    }

    // Normal ATC
    const productParent = modal?._fddProductParent;
    console.debug('FDD product parent:', productParent);
    if (!productParent) {
      console.debug('FDD product parent not found');
      return;
    }

    const atcSubmitButton = productParent.querySelector(
      'product-form buy-buttons button[type="submit"]'
    );
    console.debug('ATC button:', atcSubmitButton);

    if (!atcSubmitButton) {
      console.debug('ATC button not found');
      return;
    }

    const form = atcSubmitButton.closest('form');
    if (!form) {
      console.debug('ATC form not found');
      return;
    }

    form.requestSubmit(atcSubmitButton);
    return;
  }

  const closeButton = event.target.closest('.SpecialClose, .pdp-fdd-modal .overlay');
  if (closeButton) {
    event.preventDefault();
    const modal = document.querySelector('.pdp-fdd-modal');

    if (modal) {
      modal.classList.remove('open');
      modal._fddProductParent = null;
    }
    fddPurchaseType = 'cart';
    return;
  }

}, true);